var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a99d;\n      }\n\n      .cls-2 {\n        fill: #42b983;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m479.401,694.343l-48-169.5c-3-1.5-7.5-1.875-10.875-.375-8.25,3.375-13.125,12-10.5,19.875-7.5-26.625,9-57,36.75-67.5,27.75-10.5,56.25,2.25,63.75,28.5l39.75,141.75,84.75-160.875c5.625-10.5,19.125-16.125,29.625-11.625s13.875,16.875,8.25,27.75l-100.5,190.875c-3.75,7.125-21.375,29.25-50.25,29.25-26.625,0-40.125-19.5-42.75-28.125Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "783.346 867.576 296.655 867.576 296.655 522.324 332.655 522.324 332.655 831.576 747.346 831.576 747.346 522.324 783.346 522.324 783.346 867.576"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "852.485 545.952 540 261.134 227.516 545.952 203.265 519.346 540 212.424 876.735 519.346 852.485 545.952"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "747.346 371.326 747.232 279.399 651.981 279.516 651.936 243.516 783.187 243.355 783.346 371.281 747.346 371.326"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVIcon);
export default __webpack_public_path__ + "static/media/v-icon.9ae3459b4075dd47c5965f469a93f02e.svg";
export { ForwardRef as ReactComponent };